<span class="table-cell-icons">
  @for (icon of icons(); track icon.name) {
    <span class="table-cell-icon" [attr.title]="icon.label" [attr.aria-label]="icon.label">
      <lib-app-icon [icon]="icon.name" [size]="iconSize()" />
    </span>
  }
</span>
